/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

// Recurso padrão (com :id) — endpoint novo, isolado:
// GET/POST /api/v1/accounts/:account_id/custom_sidebar_menus
// PATCH/DELETE /api/v1/accounts/:account_id/custom_sidebar_menus/:id
class CustomSidebarMenusAPI extends ApiClient {
  constructor() {
    super('custom_sidebar_menus', { accountScoped: true });
  }
}

export default new CustomSidebarMenusAPI();
